
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm2.914-17.313c.677 0 1.25-.227 1.719-.683.469-.456.703-1.01.703-1.66 0-.651-.234-1.205-.703-1.66-.469-.456-1.042-.684-1.719-.684-.651 0-1.21.228-1.68.684a2.229 2.229 0 00-.703 1.66c0 .65.235 1.204.703 1.66a2.325 2.325 0 001.68.684zm-6.328 0c.651 0 1.21-.227 1.68-.683.468-.456.703-1.01.703-1.66 0-.651-.235-1.205-.703-1.66a2.325 2.325 0 00-1.68-.684c-.677 0-1.25.228-1.719.684a2.229 2.229 0 00-.703 1.66c0 .65.234 1.204.703 1.66.469.456 1.042.684 1.719.684zm-3.672 2.461C7.638 17.643 7 18.308 7 19.141v2.109h11.25v-2.11c0-.833-.651-1.497-1.953-1.992-1.302-.494-2.54-.742-3.711-.742-1.172 0-2.396.248-3.672.742zm10-.312c-.26 0-.482.013-.664.039.469.365.794.697.977.996.182.3.273.723.273 1.27v2.109h5v-2.11c0-.807-.605-1.393-1.816-1.757a13.004 13.004 0 00-3.77-.547z"}})])
          )
        }
      }
    